export default __webpack_public_path__ + "static/1-no-internet-connection-1888b8cd741c90ab83ce294545099716.png";